import { useSessionStorage } from "context/sessionStorage"
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { usePaymentTypeProvider } from "./usePaymentType"
import { usePaymentProvider } from "context/paymentContext"
import { useAnyProvider } from "hooks/Context"
import { useDateDifference } from "hooks/useDateDifference"
import dayjs from "dayjs"
import { UsePaymentCardProps } from "../components/PaymentCard/types"
import usePaymentStore, { DataSessionPaymentProps } from "../components/PaymentCard/useStorage"
import useExpensesStore from "hooks/useExpensesStorage"

export const usePaymentCard = ({ accommodation }: UsePaymentCardProps) => {

    const { paymentData } = usePaymentStore();

    const [nights, setNights] = useState<any>()

    const { getFromSessionStorage } = useSessionStorage()

    const location = useLocation()
    const validationCupom = location.pathname === '/payment' ? true : false

    const { typePayment } = usePaymentTypeProvider()
    const { totalValue, reserveDetails } = usePaymentProvider()
    const { date, setDate } = useAnyProvider()
    const { expensesData } = useExpensesStore();
    const { accommodationName, address, mainImage } = accommodation ?? reserveDetails
    const { dayDifference: difference, weeklyDifference: weekValue } = useDateDifference(date)
    const [hasCodePix, setHasCodePix] = useState<string | null>(null)

    const discountDifference = expensesData && (expensesData.definedDailyValue * difference) - (expensesData.definedDailyValue * difference * 0.1)

    const discountValue = expensesData && (expensesData.definedDailyValue * difference * 0.1)

    // const cupomIcon = require('../../assets/svg/Cupom.svg').default;

    useEffect(() => {
        const paymentDetails = getFromSessionStorage('payment');
        if (paymentDetails !== null) {
            setNights(paymentDetails.difference)
        } else {
            setNights(difference)
        }
        const getDate = getFromSessionStorage('reserver')
        if (getDate) {
            const dates = [dayjs(getDate.arrival_date).toDate(), dayjs(getDate.departure_date).toDate()];
            setDate(dates);
        }
        const codePix = getFromSessionStorage('hasCodePix')
        if (codePix) {
            setHasCodePix(codePix)
        }
    }, []);

    const initialState: DataSessionPaymentProps = {
        reserveDetails: {
            id: '',
            accommodationName: '',
            mainImage: '',
            address: {
                street: '',
                city: '',
                stateCode: '',
                area: '',
            },
        },
        weekValue: 0,
        difference: 0,
        nightValue: 0,
        total: 0,
        discount: false,
        condominiumValue: 0,
        midStayValue: 0,
        iptu: 0,
        cleaningValue: 0,
        pacoteYogha: 0,
        pixCode: false,
    };

    return {
        mainImage,
        accommodationName,
        dataPayment: paymentData ?? initialState,
        typePayment,
        hasCodePix,
        address,
        date,
        weekValue,
        nights,
        expensesData,
        discountDifference,
        discountValue,
        validationCupom,
        difference,
        totalValue
    }
}